import { darken } from 'polished';
import styled, { css } from 'styled-components';
import { Colors } from '.';

export const HeaderButton = styled.div<{ active?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: 2.5rem;
    height: 2.5rem;
    margin: 0 0.25rem;
    color: ${Colors.primaryDark};
    cursor: pointer;
    user-select: none;

    > * {
        position: relative;
    }

    span {
        font-weight: 450;
        margin-left: 0.3rem;
        white-space: nowrap;
    }

    &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 125%;
        height: 125%;
        background: ${Colors.l1};
        border-radius: 2.5rem;
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.8);
        transition:
            opacity 200ms ease-out,
            transform 200ms cubic-bezier(0, .99, .2, 1.14);
        pointer-events: none;
    }

    &:active {
        &:before {
            background: ${darken(0.05, Colors.l1)};
        }
    }

    ${p => !p.active ? '' : css`
        &:before {
            opacity  : 1;
            background: ${darken(0.05, Colors.l1)};
            transform: translate(-50%, -50%) scale(1);
        }
    `}

    &:hover, &:active {
        &:before {
            opacity  : 1;
            transform: translate(-50%, -50%) scale(1);
            transition: none;
        }
    }
`;
